function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@babel_runtime@7.7.2@@babel/runtime/helpers/interopRequireDefault.js
// module id = 5
// module chunks = 0 1 2